import { getCountries, getCountryCallingCode, Country } from 'react-phone-number-input';
import ru from 'react-phone-number-input/locale/ru.json';

export type CountryCode = {
  code: Country;
  dialCode: string;
  name: string;
};

const allCountries = getCountries();

const ruLocale = ru as Record<string, string>;

// Россия как Country, чтобы TypeScript не ругался
export const RUSSIA: Country = 'RU';

const sortedCountries: Country[] = [
  RUSSIA, // Россия всегда первой
  ...allCountries
    .filter((code) => code !== RUSSIA)
    .sort((a, b) => {
      const nameA = ruLocale[a] || a;
      const nameB = ruLocale[b] || b;

      return nameA.localeCompare(nameB, 'ru');
    }),
];

export const COUNTRIES: CountryCode[] = sortedCountries.map((code) => ({
  code,
  dialCode: `+${getCountryCallingCode(code)}`,
  name: ruLocale[code] || code,
}));

export const DEFAULT_COUNTRY = COUNTRIES[0]; // Россия

export const getCountryByCode = (code: Country): CountryCode | undefined => {
  return COUNTRIES.find((country) => country.code === code);
};
